export default function initScrollHeader() {
  const header = document.querySelector('.header');
  const classScroll = 'scrolled';

  window.addEventListener('scroll', ()=> {
    if(window.scrollY > 100) {
      if(!header.classList.contains(classScroll)) {
        header.classList.add(classScroll);
      }
    } else {
      if(header.classList.contains(classScroll)) {
        header.classList.remove(classScroll);
      }
    }
  });
}